import _ from "lodash";
import { PRODUCT_CODE } from "../Foundation";

const memberServicePath = '/member-service/v2';
const oddsServicePath = '/sports-service/sv';
const betServicePath = '/bet-placement';
const vsServicePath = '/vs-service';
const templateServicePath = '/estharmb/data-resoures/template-layout';
const liveScoreServicePath = '/livescore-notifier';
const paymentServicePath = '/payment/web';
const iforiumServicePath = '/iforium-service';
const solidGameLaunchPath = 'sg/get-game-launch-url';
const captchaServicePath = '/captcha-mgmt';
const agGameImagePath = '/aggame/images/';
const ptGameImagePath = '/images/games/';
const memberCasinoServicePath = '/member-casino-service';
const betslipServicePath = 'member-betslip/v2'
const memberAuthServicePath = '/member-auth/v2';
const WagerMode = {
    DANGER_ZONE: 'dz',
    LIVE_DELAY: 'ld'
}

const getBetslipEndpoint = () => {
    return window.env.newBetslipEndpointsEnabled
      ? betslipServicePath
      : memberServicePath
  
}

const getAuthEndpoint = () => {
    const path = (window.env || {}).enableUseMemberAuthEndpoints ? memberAuthServicePath : memberServicePath;
    const account = `${path}/account`;
    const otp = `${account}/otp`;
    const affiliate = `${path}/affiliate`;
    const register = `${path}/register`;

    return { path, account, otp, affiliate, register };
};

const getCasinoEndpoint = (isSkipFeatureFlag) => {
    return isSkipFeatureFlag || window.env.enableUseMemberCasinoEndpoints
      ? memberCasinoServicePath
      : memberServicePath
}
const getBetPlacementEndpointVersion = () => window.env.betPlacementV4Enabled ? 'V4' : 'V2';

const APIS = {

    /**
     * Get furured games event.
     */
    getFuturedGamesEvent: function(params) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/em-odds/events/feature?${params}&wm=${wm}`;
    },
    
    getEuroSportNormalEvents: (params)  => {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/odds/events?${params}&wm=${wm}&cbl=true`;
    },

    getEuroLiveGames: (params)  => {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/em-odds/events/live?${params}&wm=${wm}`;
    },

    getEuroSportSpecialEvents: (params)  => {
        return `${oddsServicePath}/em-outRight/odds?${params}`;
    },

    getEuroOddsEvents: (params)  => {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/em-odds/events?${params}&wm=${wm}`;
    },

    /**
     * Get statement info
     */
    getStatement: function(params) {
        return `${memberServicePath}/statement2?${params}`;
    },
    /**
     * get member-service path
     */
    getMemberServicePath: function () {
        return memberServicePath;
    },

    /**
     * AG game image path
     */
    getAgGameImagePath: function () {
      return agGameImagePath;
    },

    /**
     * PT game image path
     */
    getPTGameImagePath: function () {
      return ptGameImagePath;
    },
    
    /**
     * template-service
     */
    templateLoadURL: function () {
        let url = `${memberServicePath}/mb-config`; //from server
        return url;
    },

    getClickLogURL: function (query) {
        let url = `${getAuthEndpoint().affiliate}/submit${query}`;
        return url;
    },

    templateLoadURLLocal: function (skinName) {
        let url = `${templateServicePath}/${skinName}.json`; //from local
        return url;
    },

    /**
     * member-service
     */
    memberLoginURL: function () {
        return `${getAuthEndpoint().path}/login`;
    },

    memberAuthTokenURL: function () {
        return `${getAuthEndpoint().path}/auth-token`;
    },
    
    memberAuthenticateURL: function () {
        return `${getAuthEndpoint().path}/auth`;
    },

    memberLogoutURL: function () {
        return `${getAuthEndpoint().path}/logout`;
    },

    accountBalanceURL: function () {
        return `${memberServicePath}/account-balance`;
    },

    accountFullInfoURL: function () {
        return `${memberServicePath}/account-full-info`;
    },

    dataNoCache: function () {
        return `${memberServicePath}/data.nocache`;
    },

    dataNoCacheV2: function () {
        return `${memberServicePath}/data.nocache-v2`;
    },

    getGuestSetting: function () {
        return `${memberServicePath}/get-guest-setting`;
    },

    listSportHasLSURL: function () {
        return `${memberServicePath}/listSportHasLS`;
    },

    mybetURL: function () {
        return `${memberServicePath}/my-bets`;
    },

    bettingBudgetsURL: function () {
        return `${memberServicePath}/betting-budgets`;
    },

    multiUpdateOddsURL: function (selectionData) {
        return `${memberServicePath}/multiUpdateOdds?selectionData=${selectionData}`;
    },

    singleTicketURL: function (selectionData) {
        return `${memberServicePath}/ticket?selectionData=${selectionData}`;
    },

    multiTicketURL: function (selectionData) {
        return `${memberServicePath}/multiTicket?selectionData=${selectionData}`;
    },

    oddsSelectionsURL: function () {
      return `${memberServicePath}/odds-selections`;
    },
    
    specialTicketsURL: function () {
        return `${memberServicePath}/special-tickets`;
    },

    updateSpecialTicketsURL: function () {
        return `${memberServicePath}/update-special-tickets`;
    },

    oddsSelectionsUpdateURL: function () {
        return `${getBetslipEndpoint()}/odds-selections-update`;
    },

    allOddsSelectionsURL: function () {
        return `${getBetslipEndpoint()}/all-odds-selections`;
    },

    allOddsSelectionsUpdateURL: function () {
        return `${memberServicePath}/all-odds-selections-update`;
    },

    updateParlayTicketURL: (params) => {
        return `${getBetslipEndpoint()}/update-parlay-ticket?${params}`;
    },

    announcementURL: function () {
        return `${memberServicePath}/announcement/list-limit`;
    },

    updateTimeReadURL: function () {
        return `${memberServicePath}/announcement/update-read-annoucement`;
    },

    announcementListURL: function (dataQueryParam) {
        return `${memberServicePath}/announcement/list?${dataQueryParam}`;
    },

    messageListURL: function (pageNo) {
        return `/member-service/message/list`;
    },


    lastMessageURL: function (dataQueryParam) {
        return `${memberServicePath}/message/lastMessage?${dataQueryParam}`;
    },

    activeProductsURL: function (pageNo) {
        return `${memberServicePath}/getActiveProducts`;
    },

    productFilterURL: function () {
        return `${memberServicePath}/getProductFilter`;
    },

    sportsLeaguesFilterURL: function () {
        return `${memberServicePath}/getSportsLeaguesFilter`;
    },

    //product: all, casino, playtech, ion, ag, agin
    wagerFilterURL: function (product) {
        if (product === 'All')
            return `${memberServicePath}/wager-filter`;
        else {
            let strProd = product.toLowerCase();
            return `${memberServicePath}/${strProd}/wager-filter`;
        }
    },

    preferencesURL: function () {
        return `${memberServicePath}/preferences`;
    },
    
    quickStakeURL: function () {
        return `${memberServicePath}/quick-stake/get-info`;
    },

    resultsSportsURL: function (params) {
        return `${memberServicePath}/results/em-sports?${params}`;
    },

    resultsLeaguesURL: function (params) {
        return `${memberServicePath}/results/em-leagues?${params}`;
    },

    resultsEventsURL: function (params) {
        return `${memberServicePath}/results/events?${params}`;
    },

    selfExcludsionsURL: function (days) {
        if (days == null) {
            return `${memberServicePath}/self-excludsion`;
        }
        else {
            return `${memberServicePath}/self-excludsion?days=${days}`;
        }
    },

    sportsSortingURL: function (country) {
        return `${memberServicePath}/sports-sorting?c=${country}`;
    },

    saveSportsSortingURL: function () {
        return `${memberServicePath}/sports-sorting`;
    },

    /**
     * promotion service
     */
    getPromotionInfo: function (lng) {
        return `${memberServicePath}/slider/getPromotionInfo?lang=${lng}`;
    },

    validateWelcomeBonus: function() {
      return `${memberServicePath}/bonusPromotion/validateWelcomeBonus`;
    },

    validateReactivationBonus: function() {
      return `${memberServicePath}/bonusPromotion/validateReactivationBonus`;
    },

    validateCashbackRebateBonus: function() {
      return `${memberServicePath}/bonusPromotion/validateCashbackRebateBonus`;
    },

    claimWelcomeBonus: function() {
      return `${memberServicePath}/bonusPromotion/claimWelcomeBonus`;
    },

    claimReactivationBonus: function() {
      return `${memberServicePath}/bonusPromotion/claimReactivationBonus`;
    },

    claimCashbackRebate: function() {
      return `${memberServicePath}/bonusPromotion/claimCashbackRebate`;
    },

    /** end */

    reportSystemErrorURL: function () {
        return `${memberServicePath}/report-system-error`;
    },

    acceptTCURL: function(promoEmail, version) {
        return `${memberServicePath}/acceptTC?promoEmail=${promoEmail}&version=${version}`
    },

    memberGetCountryAndCurrency: function() {
        return `${getAuthEndpoint().register}/CountryAndCurrency?c=Others`
    },

    memberRefreshCaptcha: function() {
        return `${memberServicePath}/captcha?${new Date().getTime()}`
    },

    getCaptchaImage: function(category) {
        return `${captchaServicePath}/captcha/get?category=${category}&${new Date().getTime()}`
    },
    
    activationLink: function() {
        return `${getAuthEndpoint().register}/rq_activation_link?originUrl=${window.location.origin}`
    },

    memberDoForgotUsername: function() {
        return `${getAuthEndpoint().account}/doForgotUsername`
    },
    
    memberDoForgotEmail: function() {
        return `${getAuthEndpoint().account}/doForgotEmail`
    },

    memberDoForgotPassword: function() {
        return `${getAuthEndpoint().account}/doForgetPassword`
    },
    memberCheckLoginId: function() {
        return `${memberServicePath}/register/check-loginId`
    },
    memberDoSignUp: function() {
        return `${getAuthEndpoint().register}/doSignup`
    },
    memberGetBanks: function() {
        return `${getAuthEndpoint().register}/get-banks`
    },
    memberGetWallets: function(currency) {
        return `${getAuthEndpoint().register}/get-wallets?currency=${currency}`
    },
    memberGetActivePayments: function() {
        return `${paymentServicePath}/bank/get-all-pc-active-deposit-payment-type`
    },

    memberGetSupportedPaymentTypes: function() {
        return `${paymentServicePath}/bank/get-supported-payment-type`
    },

    memberGetPinPayPaymentMethods: function() {
        return `${paymentServicePath}/bank/get-supported-payment-methods`
    },

    memberGetPinPaySupportedBanks: function() {
        return `${paymentServicePath}/bank/get-supported-banks`
    },

    memberAddBankingAccount: function() {
        return `${paymentServicePath}/bank/add`
    },
    /**
     * odds-service
     */
    sportsMarketURL: function (country, v) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/menu/sports-markets?c=${country}&v=${v}&wm=${wm}`;
    },

    playtechGamesURL: function () {
        return `${memberServicePath}/p/playtech-service/game.gameGroupHtml5`;
    },

    playtechGamesByIdURL: function (id) {
        return `${memberServicePath}/p/playtech-service/game.gameGroupHtml5/${id}`;
    },

    /**
     * asia odds-service
     */
    asiaSportsMarketURL: function (country, v) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/am/sports-markets?c=${country}&v=${v}&wm=${wm}`;
    },

    esportMarketURL: function (country, v) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/menu/esport-market?c=${country}&v=${v}`;
    },

    oddsEventsURL: function (dataQueryParam) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/odds/events?${dataQueryParam}&wm=${wm}`;
    },

    /**
     * Get Asia odds URL
     */
    asiaOddsEventsURL: function (dataQueryParam) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/am/events?${dataQueryParam}&wm=${wm}`;
    },

    getDisplayPeriod: () => {
        return `${oddsServicePath}/odds/periods-default-setting`;
    },

    /**
     * Get Asia Outright odds URL
     */
    asiaOutrightOddsURL: function (dataQueryParam) {
      return `${oddsServicePath}/am/outright?${dataQueryParam}`;
    },

    /**
     * Get Asia eSport Outright odds URL
     */
    asiaEsportOutrightOddsURL: function (dataQueryParam) {
      return `${oddsServicePath}/am/e-sport/outright?${dataQueryParam}`;
    },

    classicSportsMarketURL: function (country) {
      return `${oddsServicePath}/menu/classic-sports-markets?c=${country}`;
    },
    /**
     * bet-placement
     */

    betPlacementBuyURL: function (uniqueRequestId) {
        return `${betServicePath}/buy${getBetPlacementEndpointVersion()}?uniqueRequestId=${uniqueRequestId}`;
    },

    betPlacementMultiBuyURL: function (uniqueRequestId) {
        return `${betServicePath}/multiBuyV1?uniqueRequestId=${uniqueRequestId}`;
    },

    /**
     * vs-service
     */
    startBetURL: function (uniqueRequestId) {
        return `${vsServicePath}/game/start-bet`;
    },

    /**
     * Get outright leagues
     */
    
    getOutrightLeaguesURL: (sportId, lgName) => {
      if (lgName) { // for esports
        return `${oddsServicePath}/outRight/es-leagues?sportId=${sportId}&lgName=${lgName}`;  
      }
      return `${oddsServicePath}/outRight/leagues?sportId=${sportId}`;
    },

    /**
     * Get Asia outright leagues
     */
    
    getAsiaOutrightLeaguesURL: (parameters) => {
      return `${oddsServicePath}/am/outright/leagues?${parameters}`;
    },

    /**
     * Get normal leagues
     */
    getLeaguesURL: (sportParameters) => {
        return `${oddsServicePath}/odds/leagues?sp=${sportParameters.sp}&mk=${sportParameters.mk}&btg=${sportParameters.btg}&d=${sportParameters.d}&tm=${sportParameters.tm}&c=${sportParameters.c}&l=${sportParameters.l}&pa=${sportParameters.pa}`;
    },

    /**
     * Get esport leagues
     */
    getEsportLeaguesURL: (esportParams) => {
      return `${oddsServicePath}/odds/es-leagues?sp=${esportParams.sp}&mk=${esportParams.mk}&btg=${esportParams.btg}&d=${esportParams.d}&tm=${esportParams.tm}&c=${esportParams.c}&l=${esportParams.l}&pa=${esportParams.pa}&lgName=${esportParams.lgName}`;
    },

    /**
     * Get Asia eSport leagues
     */
    getAsiaEsportLeaguesURL: (esportParams) => {
      return `${oddsServicePath}/am/es-leagues?${esportParams}`;
    },

    /**
     * menu service
     */
    getLiveBetURL: (liveBetParameter) => {
        if (!liveBetParameter.showAll) {
            return `${oddsServicePath}/menu/live-sports-markets?ecnt=6`;
        } else {
            return `${oddsServicePath}/menu/live-sports-markets?stcnt=0&secnt=0&ecnt=0`;
        }
    },

     /**
     * Get Iframe url
     */
      getIframeUrl: (params) => {
        return `${memberServicePath}/iframe/get-iframe-url?${params}`;
    },

    /**
     * Get multi forecast url
     */
    getMultiForecastURL: () => {
        return `${memberServicePath}/account/multi-forecast`;
    },

    /**
     * Get forecast url
     */
    getForecastURL: (params) => {
        return `${memberServicePath}/account/forecast?eid=${params.eid}&selectionId=${params.selectionId}&stk=${params.stk}&oddsFm=${params.oddsFm}&odds=${params.odds}`;
    },

    /**
     * Get teaser ticket url
     */
    getTeaserTicketURL: (params) => {
        return `${getBetslipEndpoint()}/teaser-ticket?teaserId=${params.teaserId}&ticketId=${params.ticketId}&oddsFormat=${params.oddsFormat}&legs=${params.legs}`;
    },

    /**
     * Get favourite sports
     */
    getFavouriteSportURL: (params) => {
        return `${oddsServicePath}/menu/favouriteSports?eventIds=${params.eventIds}`;
    },
    /**
     * Get MyBets Data URL
     */
    getMyBetsURL: () => {
        return `${memberServicePath}/my-bets`;
    },
    /**
     * get DeleteMyBetsWager
     */
    getDeleteMyBetsWager: (dataQuery) => {
        return `${memberServicePath}/delete-wager?wagerId=${dataQuery.wagerId}`;
    },

    /**
     * Get Outright odds URL
     */
    outrightOddsURL: function (dataQueryParam) {
      // const keyQueryOutrightForEsport = 'eSportCode';
      // const match = RegExp('[?&]' + keyQueryOutrightForEsport + '=([^&]*)').exec(dataQueryParam);
      // if (match && decodeURIComponent(match[1].replace(/\+/g, ' '))) {
      //   return `${oddsServicePath}/outRight/esport/odds?${dataQueryParam}`;
      // }
      return `${oddsServicePath}/outRight/odds?${dataQueryParam}`;
    },

    /**
     * Get Classic Outright odds URL
     */
    outrightOddsClassicURL: function (dataQueryParam) {
        const keyQueryOutrightForEsport = 'eSportCode';
        const match = RegExp('[?&]' + keyQueryOutrightForEsport + '=([^&]*)').exec(dataQueryParam);
        if (match && decodeURIComponent(match[1].replace(/\+/g, ' '))) {
          return `${oddsServicePath}/outRight/esport/odds/classic?${dataQueryParam}`;
        }
        return `${oddsServicePath}/outRight/odds/classic?${dataQueryParam}`;
      },

    /**
     * Get Outright odds URL
     */
    outrightleagueURL: function (dataQueryParam) {
        return `${oddsServicePath}/outRight/leagues?${dataQueryParam}`;
    },

    /**
     * Get teaser odds URL
     */
    teaserOddsURL: function (dataQueryParam) {
        return `${oddsServicePath}/teaser/oddsAdvance?${dataQueryParam}`;
    },

    /**
     * Remove teaser ticket url
     */
    removeTeaserTicketURL: (params) => {
        return `${getBetslipEndpoint()}/remove-teaser-ticket?teaserId=${params.teaserId}&ticketId=${params.ticketId}&oddsFormat=${params.oddsFormat}&legId=${params.legId}`;
    },

    /**
     * Buy teaser bet URL
     */
    buyTeaserBetURL: function (uniqueRequestId) {
        return `${betServicePath}/buyTeaser${getBetPlacementEndpointVersion()}?uniqueRequestId=${uniqueRequestId}`;
    },

    updateTeaserTicket: (params) => {
      return `${getBetslipEndpoint()}/update-teaser-ticket?legId=${params.legId}&ticketId=${params.ticketId}&oddsFormat=${params.oddsFormat}&legs=${params.legs}`;
    },

    removeParlayTicketUrl: (params) => {
        return `${memberServicePath}/remove-parlay-ticket?legId=${params.legId}&ticketId=${params.ticketId}&checkTicket=${params.checkTicket}&ot=${params.oddsFormat}`;
    },

    parlayRemoveSelectionsURL: (legId) => {
        return `${getBetslipEndpoint()}/parlay-remove-selection?legId=${legId}`;
    },

    correlateSelectionsURL: function () {
        return `${getBetslipEndpoint()}/correlated-selection`;
    },

    parlayOddsSelectionsURL: function () {
        return `${getBetslipEndpoint()}/parlay-odds-selections`;
    },

    parlayUpdateOddsURL: function () {
        return `${getBetslipEndpoint()}/parlay-update-odds`;
    },

    parlayUpdateTicket: function (params) {
        return `${getBetslipEndpoint()}/update-parlay-ticket?${params}`
    },

    placeParlayBetURL: (uniqueRequestId) => {
        return `${betServicePath}/buyParlay${getBetPlacementEndpointVersion()}?uniqueRequestId=${uniqueRequestId}`;
    },

    updatePitcherParlayURL: (params) => {
        return `${memberServicePath}/update-pitcher-parlay-ticket?legId=${params.legId}&pitcher1MustStart=${params.pitcher1MustStart}&pitcher2MustStart=${params.pitcher2MustStart}`;
    },

    getSliderBannerHomeURL: (params) => {
        return `${memberServicePath}/landing-mobile?lang=${params.lang}&c=${params.country}`
    },

    getAllMiniBannerURL: (params) => {
        return `${memberServicePath}/single/getAllMiniBanner?lang=${params.lang}&country=${params.country}`;
    },
    /*
    * Live Score Service
    */
    liverScoreUpdateNotify: () => {
        return `${liveScoreServicePath}/update-notify.sv`
    },

        /*
    * New Betslip Notify Service
    */
    newBetslipMobileNotify: () => {
        return `${memberServicePath}/mobile/new-betslip/accept-popup`
    },

        /*
    * Enable Live Parlays Notify Service
    */
    liveParlaysNotify: () => {
        return `${memberServicePath}/live-parlays/accept-popup`
    },

    /**
     * Classic View
     */
    getClassicSportsMarkets: (sportId, leagueId, market, eventId)  => {
        return `${oddsServicePath}/classic/sport-markets?sportId=${sportId}&lg=${leagueId}&mk=${market}${eventId ? '&ev=' + eventId : ''}`;
    },

    getClassicEventOdds: (sportId, leagueId, market, marketType, oddsType, maxLines, eventId, order, version, timeZoneId)  => {
        let liveVersion, nonLiveVersion;
        if(market == 2) {
            nonLiveVersion  = version[0];
        } else {
            liveVersion = version[0];
            nonLiveVersion = version[1];
        }
        return `${oddsServicePath}/classic/events?sp=${sportId}&lg=${leagueId}&mk=${market}&l=${maxLines}&smt=${marketType}&ot=${oddsType}
            &o=${order}${eventId ? '&ev=' + eventId : ''}${liveVersion ? '&lv=' + liveVersion : ''}&tz=${timeZoneId}${nonLiveVersion ? '&v=' + nonLiveVersion : ''
        }`;
    },

    getClassicParlayEventOdds: (sportIds, leagueIds, market, oddsType, maxLines, isParlay, order, date, version, timeZoneId) => {
      return `${oddsServicePath}/classic/events?sp=${sportIds}&lg=${leagueIds}&l=${maxLines}&mk=${market}&ot=${oddsType}&pa=${isParlay}&o=${order}&tz=${timeZoneId}${version ? '&v=' + version : ''}${date ? '&d=' + date : ''}`;
    },

    /**
     * Canino
     * Get category
     */
    getCategory: () => {
      return `${getCasinoEndpoint()}/casino/category`;
    },

    /**
     * Canino
     * Get live category
     */
    getLiveCategory: () => {
        return `${getCasinoEndpoint()}/casino/live/category`;
    },
    /**
       * Canino
       * Get live category
       */
    getKYCategory: () => {
        return `${getCasinoEndpoint()}/casino/poker/category`;
    },

    /**
     * Get Casino sliders
     */
    getCasinoSlider: (casinoSliderFilter) => {
      return `${getCasinoEndpoint()}/slider/getCasinoSlider?${casinoSliderFilter}`;
    },

    /**
     * Get Casino games
     */
    getCasinoGames: (casinoFilter) => {
      return `${getCasinoEndpoint()}/casino/mobile-games?${casinoFilter}`;
    },

    /**
     * Get Casino games
     */
    getLiveCasinoGames: (casinoFilter) => {
        return `${getCasinoEndpoint()}/casino/live/mobile-games?${casinoFilter}`;
    },
    /**
     * Get Casino games
     */
    getKYPokerGames: (casinoFilter) => {
        return `${getCasinoEndpoint()}/casino/ky/games?${casinoFilter}`;
    },

    /**
     * Get Iforium providers
     */
    getIforiumProviders: () => {
      return `${iforiumServicePath}/game/providers`;
    },

     /**
     * Canino - get Casino side bar
     */
    getCasinoSideBar: () => {
        return `${getCasinoEndpoint()}/casino/getCasinoSideBars`;
    },

    /**
     * Canino - initGameflexExpressLibrayAPI
     */
    initGameflexExpressLibray: () => {
        return `${iforiumServicePath}/game/getGameflexExpressConfig`;
    },

    /**
     * Canino - getPlayerCurrencyCode
     */
    getPlayerCurrencyCode: () => {
        return `${iforiumServicePath}/player/getCurrencyCode`;
    },

    /**
     * Canino - getPlayerSession
     */
    getPlayerSession: () => {
        return `${iforiumServicePath}/player/sessiontoken`;
    },

    /**
     * Canino - getDefaultGameIdGRVs
     */
    getDefaultGameIdGRVs: (channelId) => {
      return `${getCasinoEndpoint()}/casino/default-game-gr?${channelId}`;
    },


    /**
     * Golden Race VS - getPlayerSession
     */
    getPlayerSessionVs: () => {
        return `${iforiumServicePath}/player/sessiontokenvs`;
    },

    /**
     * Get accounts balance
     */
    getAccountsBalance: () => {
      return `${memberServicePath}/accounts-balance`;
    },

    /**
     * Transfer wallets
     */
    transferWallets: () => {
      return `${paymentServicePath}/transfer/process`;
    },

     /**
     * Get game dispatcher Url
     */
    getGameDispatcherUrl: (dataQueryParam) => {
      return `${getCasinoEndpoint()}/getGameDispatcherUrl?${dataQueryParam}`;
    },

    /**
     * Get AG game dispatcher Url
     */
    getAGGameDispatcherUrl: (dataQueryParam) => {
      return `${getCasinoEndpoint()}/getAGGameDispatcherUrl?${dataQueryParam}`;
    },

    /**
     * Get Solid game launcher Url
     */
    getSolidGameLaunchPath: function (gameCode) {
        return `${memberServicePath}/${solidGameLaunchPath}/${gameCode}`;
    },

    /**
     * Get casino login status
     */
    getCasinoLoginStatus: () => {
      return `${memberServicePath}/getCasinoLoginStatus`;
    },

    /**
     * Get CR855 game path
     */
    getCR855GamePath: function () {
      return `${memberServicePath}/crown-service/login`;
    },

    /**
     * Check Playtech player online
     */
    checkPlaytechPlayerOnline: () => {
      return `${memberServicePath}/p/playtech-service/player/online`;
    },

    /**
     * Logout playtech user
     */
    logoutPlaytechUser: () => {
        return `${memberServicePath}/p/playtech-service/player/logout`;
      },

    /**
     * Get playtech player
     */
    getPlaytechPlayer: () => {
      return `${memberServicePath}/playtech-service/login`;
    },

    /**
     * Get Casino Backround
     */
    getCasinoBackground: (dataQueryParam) => {
      return `${memberServicePath}/single/getCasinoBanner?${dataQueryParam}`;
    },

    /**
     * Get active product wallet
     */
    getActiveProductWallet: () => {
      return `${getCasinoEndpoint()}/getActiveProductWallet`;
    },

    /**
     * Check Affiliate Code
     */
    checkAffiliateCode: () => {
      return `${getAuthEndpoint().register}/check-affiliate`;
    },

    /**
     * Check Promo Code
     */
    checkPromoCode: () => {
        return `${getAuthEndpoint().register}/doValidatePromotionCode`;
      },

    getWagerFilter : () => {
        return `${memberServicePath}/wager-filter`;
    },  
   getProfile : () => {
        return `${memberServicePath}/profile`;
    },

    getNgcUrl : (page, lang) => {
        return `${getAuthEndpoint().path}/ngc-api/generateUrl?page=${page}&lang=${lang}`;
    },

    changePassword : () => {
        return `${getAuthEndpoint().path}/changePassword`;
    },
   
    changePasswordToLogin : () => {
        return `${getAuthEndpoint().path}/changePasswordToLogin`;
    },

    /**Asia Betslip */
    getAsiaSingleOdds: function(params) {
        return `${memberServicePath}/ticket?${params}`;
    },
    getAsiaOutrightOdds: function(params) {
        return `${memberServicePath}/outright-ticket?${params}`;
    },
    /**
     * Update locale
     */
    updateLocale : (lang) => {
        return `${memberServicePath}/locale?lang=${lang}`;
    },

    getActiveWallets : () => {
        return `${memberServicePath}/getActiveWallets?_+${Math.random()}`;
    }, 

    getStatements : (dataQueryParam) => {
        return `${memberServicePath}/statement2?${dataQueryParam}`;
    },

    getTransactions: function (query) {
        return `${memberServicePath}/transactions${query}`;
    },

    wagerDetailURL: function (params) {
        return `${memberServicePath}/getWagerDetails?${params}`;
    },

    transactionDetailURL: function (params) {
        return `${memberServicePath}/getTransactionDetails?${params}`;
    },

    getMessages: function(dataQueryParam) {
        return `${memberServicePath}/message/mb-list?${dataQueryParam}`;
    },

    deleteMessageListURL: function () {
        return `${memberServicePath}/message/update-message-to-read`;
    },


    resultsSportsAsiaURL: function() {
        return `${memberServicePath}/results/sports`;
    },

    resultsLeaguesAsiaURL: function(dataQueryParam) {
        return `${memberServicePath}/results/leagues?${dataQueryParam}`;
    },
    getCountryAndCurrency: function() {
        return `${getAuthEndpoint().register}/CountryAndCurrency`
    },
    getUserLocation: function() {
        return `https://ipinfo.io/json`
    },
    checkEmail: function() {
        return  `${getAuthEndpoint().register}/check-email`
    },
    
    requestActivationURL: function() {
        return `${getAuthEndpoint().register}/rq_activation_link`;
    },

    getB2BTransactionsURL : function() {
        return `${memberServicePath}/b2b/transaction/`;
    },

    getMaintenanceTemplate: () => {
      return `${memberServicePath}/getMaintenanceByLang`;
    },

    getSuspendWagering: () => {
      return `${memberServicePath}/system/status`;
    },

    getLeagueTranslationByLang: () => {
        return `${memberServicePath}/getLeagueTranslationByLang`;
      },

    getLoginMessage: () => {
      return `${memberServicePath}/message/getLoginMessage`;
    },

    readLoginMessage: () => {
      return `${memberServicePath}/message/readLoginMessage`;
    },

    getPrestigeClubURL: (params) => {
      return `${memberServicePath}/prestige-club?${params}`;
    },

    updateDefaultView : (view) => {
        return `${memberServicePath}/updateDefaultView?defaultView=${view}`;
    }, 
    
    updateFingerPrintId: (dataQueryParam) => {
      return `${memberServicePath}/finger-print?${dataQueryParam}`;
    },

    getPromotionSurvey: (surveyId)  => {
        return `${memberServicePath}/promotion-survey/get-question?surveyId=${surveyId}`;
    },

    getMyBonus: function ({ dateRange, lang, fromDate, toDate }) {
        return `${memberServicePath}/account/get-bonuses?dateRange=${dateRange}&lang=${lang}&fromDate=${fromDate}&toDate=${toDate}`;
    },
    getTermAndCondition: function (params) {
        return `${memberServicePath}/account/getPromotionInfoById?promotionId=${params.promotionId}&lang=${params.lang}`;
    },

    submitPromotionSurvey: () =>{
        return `${memberServicePath}/promotion-survey/submit-survey`;
    },

    getSportPeriodDesc: () =>{
      return `${oddsServicePath}/odds/periods`;
    },

    registerParticipantByCampaignId: function () {
        return `${memberServicePath}/campaign/participant`;
    },

    getBoardsByCampaignId: function (campaignId) {
        return `${memberServicePath}/campaign/board/${campaignId}`;
    },

    getScoresByCampaignId: function (campaignId) {
        return `${memberServicePath}/campaign/score/${campaignId}`;
    },

    getParticipantByCampaignId: function (campaignId) {
        return `${memberServicePath}/campaign/participant/${campaignId}`;
    },
    getActiveLink: (dataQueryParam) => {
      return `${getAuthEndpoint().register}/activation_link?${dataQueryParam}`;
    },
    /**
     *  Multi-factor Authentication (MFA) 
     * 
    */
    getMfaSettingInfo: () => {
        return `${getAuthEndpoint().otp}/getMfaSettingInfo`
    },
    setMfaMethodType: (params) => {
        return `${getAuthEndpoint().otp}/setMfaMethodType?${params}`
    },
    getQRCode: () => {
        return `${getAuthEndpoint().otp}/initQr`
    },
    getSecretKey: () => {
        return `${getAuthEndpoint().otp}/initQrOtpCode`
    },
    saveQrOtp: (params) => {
        return `${getAuthEndpoint().otp}/saveQrOtp?${params}`
    },
    sendOtpToEmail: () => `${getAuthEndpoint().otp}/sendOtpAuthMobileApp`,
    confirmOtpAuthMobileApp: () => `${getAuthEndpoint().otp}/confirmOtpAuthMobileApp`,
    getUpdateReasonDpFailedURL: (params) => {
        return `${memberServicePath}/dp/floaded?${params}`
    },
    getDPIframeURL: (params) => `${window.env.dynamicParameterIframeUrl}?${params}`,
    getCasinoGameByPath: (casinoFilter) => `${getCasinoEndpoint()}/casino/get-game-by-path?${casinoFilter}`,
    getSearchResults: (params) => `${oddsServicePath}/euro/search?${params}`,
    getGamesDispatcherUrl: (params, dispatcherUrl) => {
        // open BG game only new casino endpoint
        const isBGGame = [PRODUCT_CODE.BG].includes(new URLSearchParams(params).get('productCode'));
        const basePath = getCasinoEndpoint(isBGGame);
        return `${basePath}/${dispatcherUrl}?${params}`;
      },
    getWithdrawalMethod: function() {
        return `${memberServicePath}/credit-withdrawal-methods`;
    },
    getWithdrawalCurrencies: function() {
        return `${memberServicePath}/credit-withdrawal-currencies`;
    },
    submitWithdrawal: function () {
        return `${memberServicePath}/account/request-withdrawal`;
    },
    doVIPForgotPassword: () => `${getAuthEndpoint().account}/forget-password`,
    verifiedChangePassWord: (params) => `${getAuthEndpoint().account}/change-password-verification?${params}`,
    resetPassword: () => `${getAuthEndpoint().account}/reset-password`,
    keepAlive: () => `${memberAuthServicePath}/keep-alive`,
    forfeitBonus: (txnNo) => `${memberServicePath}/bonus/forfeit?txnNo=${txnNo}`,
    toggleLoginOTP: () => `${getAuthEndpoint().otp}/toggleLogin2FA`,
    resendOtpLogin2FA: () => `${getAuthEndpoint().otp}/resendOtpLogin2FA`,
    forfeitSubscriptionBonus: (promotionId) => `${memberServicePath}/bonus/forfeit-subscription?promotionId=${promotionId}`,
    getZendeskToken: (params) => `${memberServicePath}/get-zendesk-token?${params}`,
    getOtpType: (params) => `${memberAuthServicePath}/getOtpType?${params}`,
    getDocumentRequest: () => `${memberServicePath}/kyc/request`,
    uploadDocumentRequest: (requestId) => `${memberServicePath}/kyc/upload${requestId ? `?requestId=${requestId}` : ''}`,
}

export default APIS;



// WEBPACK FOOTER //
// ./src/app/common/config/APIs.js